document.addEventListener('DOMContentLoaded', function() {
  const modalEl = document.getElementById('modal-quickview')
  if (!modalEl) return
  const bsModal = new bootstrap.Modal(modalEl)
  const mediaEl = modalEl.querySelector('#quickview-media')
  const contentEl = modalEl.querySelector('#quickview-content')
  const titleEl = modalEl.querySelector('#modal-quickview-label')

  function formatPrice(price) {
    try {
      return Shopify.formatMoney(price)
    } catch (e) {
      return price
    }
  }

  async function openQuickview(handle) {
    titleEl.textContent = ''
    mediaEl.innerHTML = ''
    contentEl.innerHTML = '<p class="text-center">Loading…</p>'

    try {
      const res = await fetch(`/products/${handle}.js`)
      if (!res.ok) throw new Error('Failed to load product')
      const product = await res.json()

      titleEl.textContent = product.title

      // media
      mediaEl.innerHTML = ''
      if (product.images && product.images.length) {
        const img = document.createElement('img')
        img.src = product.images[0]
        img.alt = product.title
        img.className = 'img-fluid'
        mediaEl.appendChild(img)
      }

      // content: title, vendor, price, options
      const wrapper = document.createElement('div')
      wrapper.innerHTML = `
        <p class="mb-2 text-muted">${product.vendor || ''}</p>
        <div id="quickview-price" class="mb-3"></div>
        <form id="quickview-form">
          <div id="quickview-options"></div>
          <div class="d-flex align-items-center justify-content-between gap-6 mt-12 mb-6">
            <input type="number" name="quantity" value="1" min="1" class="form-control form-control-md me-2" style="width:5.5rem;" />
            <button type="submit" class="btn btn-primary">Add to cart</button>
          </div>
        </form>
      `

      contentEl.innerHTML = ''
      contentEl.appendChild(wrapper)

      const priceEl = contentEl.querySelector('#quickview-price')
      if (product.variants && product.variants.length) {
        priceEl.textContent = formatPrice(product.variants[0].price)
      }

      const optionsContainer = contentEl.querySelector('#quickview-options')

      if (product.variants.length > 1) {
        product.options.forEach((optNameRaw, idx) => {
          const optName = (typeof optNameRaw === 'string') ? optNameRaw : (optNameRaw && (optNameRaw.name || optNameRaw.label || optNameRaw.value)) || String(optNameRaw)
          // collect unique option values for this option index
          const values = []
          product.variants.forEach(variant => {
            const v = variant.options[idx]
            if (!values.includes(v)) values.push(v)
          })

          const group = document.createElement('div')
          group.className = 'mb-3'
          const label = document.createElement('div')
          label.className = 'form-label small mb-1'
          label.textContent = optName

          const radios = document.createElement('div')
          radios.className = 'quickview-option-group d-flex flex-wrap gap-6'

          values.forEach((val, vIdx) => {
            const valueText = (val === null || val === undefined) ? '' : (typeof val === 'string' ? val : String(val))
            const id = `quickview_opt_${idx}_${vIdx}`

            const wrapper = document.createElement('div')
            wrapper.className = 'form-check'

            const input = document.createElement('input')
            input.className = 'form-check-input quickview-option-radio'
            input.type = 'radio'
            input.name = `options[${idx}]`
            input.id = id
            input.value = valueText
            

            const inputLabel = document.createElement('label')
            inputLabel.className = 'form-check-label quickview-option-label'
            inputLabel.htmlFor = id
            inputLabel.textContent = valueText

            wrapper.appendChild(input)
            wrapper.appendChild(inputLabel)
            radios.appendChild(wrapper)
          })

          group.appendChild(label)
          group.appendChild(radios)
          optionsContainer.appendChild(group)
        })

        // After building radios: ensure only available combinations are selectable
        const findVariantForValues = (values) => product.variants.find(v => v.options.every((o, i) => o == values[i]))

        const setInitialSelection = () => {
          const firstAvailable = product.variants.find(v => v.available) || product.variants[0]
          if (!firstAvailable) return
          product.options.forEach((_, idx) => {
            const radios = Array.from(contentEl.querySelectorAll(`input[name="options[${idx}]"]`))
            const desired = firstAvailable.options[idx]
            const match = radios.find(r => r.value == desired)
            if (match) match.checked = true
            else if (radios.length) radios[0].checked = true
          })
        }

        const updateOptionAvailability = () => {
          product.options.forEach((_, idx) => {
            const radios = Array.from(contentEl.querySelectorAll(`input[name="options[${idx}]"]`))
            radios.forEach(radio => {
              // build tentative selection using current choices but with this radio's value for idx
              const tentative = product.options.map((__, j) => {
                if (j === idx) return radio.value
                const sel = Array.from(contentEl.querySelectorAll(`input[name="options[${j}]"]`)).find(x => x.checked)
                if (sel) return sel.value
                const first = contentEl.querySelector(`input[name="options[${j}]"]`)
                return first ? first.value : ''
              })

              const match = findVariantForValues(tentative)
              const label = contentEl.querySelector(`label[for="${radio.id}"]`)
              const enabled = Boolean(match && match.available)
              radio.disabled = !enabled
              if (label) {
                label.classList.toggle('disabled', !enabled)
              }
              if (radio.disabled && radio.checked) radio.checked = false
            })

            // ensure at least one enabled option is checked for this group
            const stillRadios = Array.from(contentEl.querySelectorAll(`input[name="options[${idx}]"]`))
            if (!stillRadios.find(r => r.checked) && stillRadios.length) {
              const firstEnabled = stillRadios.find(r => !r.disabled)
              if (firstEnabled) firstEnabled.checked = true
            }
          })
        }

        // set initial and update availability
        setInitialSelection()
        updateOptionAvailability()

        // when options change, recompute availability and price
        optionsContainer.addEventListener('change', () => {
          updateOptionAvailability()
          const v = product.variants.find(vv => vv.options.every((o,i) => {
            const sel = Array.from(contentEl.querySelectorAll(`input[name="options[${i}]"]`)).find(x => x.checked)
            return sel ? sel.value == o : false
          }))
          if (v) priceEl.textContent = formatPrice(v.price)
        })
      } else {
        // single variant; store variant id in hidden input
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'id'
        input.value = product.variants[0].id
        optionsContainer.appendChild(input)
      }

      // Handle option change to update selected variant and price
      const form = contentEl.querySelector('#quickview-form')
      function getSelectedVariant() {
        if (product.variants.length === 1) return product.variants[0]
        const selected = []
        product.options.forEach((optName, idx) => {
          const radios = form.querySelectorAll(`input[name="options[${idx}]"]`)
          const checked = Array.from(radios).find(r => r.checked)
          selected.push(checked ? checked.value : '')
        })
        return product.variants.find(v => v.options.every((o, i) => o == selected[i]))
      }

      form.addEventListener('change', () => {
        const v = getSelectedVariant()
        if (v) priceEl.textContent = formatPrice(v.price)
      })

      // submit handler: add to cart using existing cart-container.add if available
      form.addEventListener('submit', async (e) => {
        e.preventDefault()
        const quantity = Number(form.querySelector('input[name="quantity"]').value) || 1
        const variant = getSelectedVariant()
        if (!variant) {
          alert('Please select a variant')
          return
        }

        const formData = new FormData()
        formData.append('id', variant.id)
        formData.append('quantity', quantity)

        const cartContainer = document.querySelector('cart-container')
        if (cartContainer && typeof cartContainer.add === 'function') {
          cartContainer.add(formData)
        } else {
          // fallback: post directly
          await fetch(`${window.Shopify.routes.cart_add_url}.js`, { method: 'POST', body: formData })
          window.location.reload()
        }

        bsModal.hide()
      })

      bsModal.show()
    } catch (err) {
      contentEl.innerHTML = '<p class="text-danger">Failed to load product.</p>'
      console.error(err)
      bsModal.show()
    }
  }

  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-quickview-handle]')
    if (!btn) return
    e.preventDefault()
    const handle = btn.dataset.quickviewHandle
    if (handle) openQuickview(handle)
  })
})
